export enum AppId {
  WASH_MASTER = 'wm',
  SERVICE_MASTER = 'sm',
  EASY_SET = 'es',
}
